import vars from '../../helpers';

function init() {
	const $animate = vars.$document.find('.js-animate');

	let duration = 1;

	$animate.each((index, item) => {
		const $item = $(item);
		let animation = null;

		if (!$item.is(':visible')) {
			$item.addClass('is-hidden');

			return;
		}

		animation = gsap.from($item, duration, {
			opacity: 0,
			y: 100,
			paused: true,
			onComplete() {
				gsap.set($item, {clearProps: 'all'});
			},
		});

		$item.on('inview', (event, isInView) => {
			if (isInView && animation) {
				let delay = 0;

				$item.removeClass('is-hidden');

				setTimeout(() => {
					animation.play();
				}, delay * 1000);

				$item.off('inview');
			}
		});
	});
}

function destroy() {
	const $animate = $('.js-animate');

	$animate.each((index, item) => {
		const $item = $(item);

		gsap.killTweensOf($item);
		gsap.set($item, {
			clearProps: 'all',
		});
		$item.off('inview').data('inview', '');
		$item.removeClass('is-animated');
	});
}

export default {
	init,
	destroy,
};
